import { useRef } from 'react'
import styled from 'styled-components'

export const ToolTip = ({
  activeData,

  locale = 'de',
}: {
  activeData?: CouncilMember

  locale?: 'de' | 'fr'
}) => {
  const toolTipRef = useRef<HTMLDivElement>(null)
  return (
    <ToolTipWrapper ref={toolTipRef} hasShadow={true}>
      {activeData && (
        <table>
          {
            <Head>
              <h4>{activeData.name}</h4>
              <b>{activeData.party}</b>
            </Head>
          }
          <Body>
            <Row>
              <EntryTitle className='provider'>Kanton</EntryTitle>
              <EntryValue className='price'>{activeData.canton}</EntryValue>
            </Row>
          </Body>
        </table>
      )}
    </ToolTipWrapper>
  )
}
const Head = styled.thead`
  display: flex;
  justify-content: space-between;
  margin: 1em;
  margin-bottom: 0;
  white-space: nowrap;
  h4 {
    width: 100%;

    margin: 0;
    display: flex;
    /* justify-content: space-between; */
    font-size: 1.25em;
    margin-bottom: 0.3em;
    font-weight: 700;
    text-align: left;
  }
`
const Body = styled.tbody`
  display: flex;
  flex-direction: column;
  margin: 1em;
  margin-top: 0;
`
const Row = styled.tr`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const EntryTitle = styled.td`
  font-size: 0.9em;
  line-height: 1.5em;
  width: 100%;
  /* white-space: nowrap; */
`
const EntryValue = styled.td<{ color?: string }>`
  font-weight: bold;
  white-space: nowrap;
  text-align: right;
  padding-left: 1em;
  /* font-size: 1.2xem; */
`
const ClosingButton = styled.button`
  pointer-events: all;
  display: grid;
  place-items: center;
  font-size: 1.5rem;
  line-height: 1;
  padding: 0.5rem;
  border: none;
  background-color: transparent;
  // disable flashing when pressing button
  -webkit-tap-highlight-color: transparent;
  color: inherit;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  svg {
    max-height: 1.5em;
  }
  &:hover {
    background-color: var(--color-black);
    color: var(--color-white);
  }
`
const RelChange = styled.div<{ change: number }>`
  display: flex;
  /* justify-content: flex-end; */
  align-items: center;
  flex-direction: row;
  font-weight: bold;
  font-size: 1.2em;
  /* color: currentColor; */
  color: ${(props) =>
    props.change > 0
      ? 'var(--change-color-red)'
      : props.change < 0
      ? 'var(--change-color-green)'
      : 'currentColor'};
  .arrow-icon {
    transition: all 500ms cubic-bezier(0.77, 0, 0.175, 1);
    width: 1em;
    height: 1em;
    margin-right: 0.5em;
    margin-left: 0.5em;
  }
`
const ToolTipWrapper = styled.div<{ hasShadow?: boolean }>`
  /* transform: translate3d(-50%, -120%, 0); */
  pointer-events: none;
  background-color: var(--tooltip-background-color);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
  font-size: 14px;
  box-shadow: rgba(0, 0, 0, 0.03) 0px 4.5px 1.3px,
    rgba(0, 0, 0, 0.035) 0px 8.6px 3.1px, rgba(0, 0, 0, 0.035) 0px 12.7px 5.5px,
    rgba(0, 0, 0, 0.04) 0px 17.3px 9.2px, rgba(0, 0, 0, 0.04) 0px 23.4px 15.1px,
    rgba(0, 0, 0, 0.047) 0px 33.5px 26.4px, rgba(0, 0, 0, 0.07) 0px 60px 57px;
  font-family: var(--font-sans-serif);
  min-width: 250px;
  max-width: 400px;
  animation: slide-in-top 0.3s ease-in-out;
  @keyframes slide-in-top {
    0% {
      box-shadow: rgba(0, 0, 0, 0.03) 0px 0px 0px,
        rgba(0, 0, 0, 0.035) 0px 0px 0px, rgba(0, 0, 0, 0.035) 0px 0px 0px,
        rgba(0, 0, 0, 0.04) 0px 0px 0px, rgba(0, 0, 0, 0.04) 0px 0px 0px,
        rgba(0, 0, 0, 0.047) 0px 0px 0px, rgba(0, 0, 0, 0.07) 0px 0px 0px;
      /* transform: translate3d(0, -50px, 0); */
      opacity: 0;
      max-height: 0;
    }
    100% {
      /* transform: translate3d(0, 0, 0); */
      opacity: 1;
      max-height: 400px;
    }
  }
`
